<section>
    <div class="container">
        <div class="contents">
            <div class="header-container">
                <h2 class="header"> {{ planSwitchData.headerContent }}</h2>
                <span>
                    <button class="xm-btn-link-light bill-amount expand" (click)="nextBillExpandFlag = !nextBillExpandFlag"
                        [attr.aria-expanded]="nextBillExpandFlag">
                        <xm-media-image class="expand-icon-bill-amount" size="height" [ngClass]="{'expanded': nextBillExpandFlag}"
                            [imageOptions]="expandIconOptions" aria-hidden="true"></xm-media-image>
                        {{ planSwitchData.estimatedNextBillCharges }}
                    </button>
                </span>
            </div>
            <div class="next-bill-date">
                <span class="title">{{ planSwitchData.effective }}</span>
            </div>
        </div>
        <!-- My Data -->
        <xm-expandable [expanded]="nextBillExpandFlag">
            <div class="items">
                <h3 class="header-title">{{ planSwitchData.myData.headerContent }}</h3>
                <div class="data">
                    <div class="panel" *ngIf="cmsData.byTheGigPlanGroup">
                        <div class="heading">
                            <span>{{ cmsData.byTheGigPlanGroup.byTheGigPlanHeader }}</span>
                            <span>
                                <button class="xm-btn-link-light expand" (click)="btgExpandFlag = !btgExpandFlag"
                                    [attr.aria-expanded]="btgExpandFlag">
                                    {{ cmsData.byTheGigPlanGroup.dataCost }}
                                    <xm-media-image class="expand-icon" size="height"
                                        [ngClass]="{'expanded': btgExpandFlag}" [imageOptions]="expandIconOptions"
                                        aria-hidden="true"></xm-media-image>
                                </button>
                            </span>
                        </div>
                        <xm-expandable [expanded]="btgExpandFlag">
                            <xm-bill-preview-expanded-data-panel
                                [byTheGigPlanGroup]="byTheGigPlanGroup"></xm-bill-preview-expanded-data-panel>
                        </xm-expandable>
                    </div>
                    <div class="panel" *ngIf="cmsData.unlimitedPlanGroup">
                        <div class="heading">
                            <span>{{ cmsData.unlimitedPlanGroup.unlimitedPlanHeader }}</span>
                            <span>
                                <button class="xm-btn-link-light expand"
                                    (click)="unlimitedExpandFlag = !unlimitedExpandFlag"
                                    [attr.aria-expanded]="unlimitedExpandFlag">
                                    {{ cmsData.unlimitedPlanGroup.dataCost }}
                                    <xm-media-image class="expand-icon" size="height"
                                        [ngClass]="{'expanded': unlimitedExpandFlag}" [imageOptions]="expandIconOptions"
                                        aria-hidden="true"></xm-media-image>
                                </button>
                            </span>
                        </div>
                        <xm-expandable [expanded]="unlimitedExpandFlag">
                            <xm-bill-preview-expanded-data-panel
                                [unlimitedPlanGroup]="unlimitedPlanGroup"></xm-bill-preview-expanded-data-panel>
                        </xm-expandable>
                    </div>
                    <div class="panel" *ngIf="cmsData.tabletPlanGroup">
                        <div class="heading">
                            <span>{{ cmsData.tabletPlanGroup.tabletPlanHeader }}</span>
                            <span>
                                <button class="xm-btn-link-light expand" (click)="tabletExpandFlag = !tabletExpandFlag"
                                    [attr.aria-expanded]="tabletExpandFlag">
                                    {{ cmsData.tabletPlanGroup.dataCost }}
                                    <xm-media-image class="expand-icon" size="height"
                                        [ngClass]="{'expanded': tabletExpandFlag}" [imageOptions]="expandIconOptions"
                                        aria-hidden="true"></xm-media-image>
                                </button>
                            </span>
                        </div>
                        <xm-expandable [expanded]="tabletExpandFlag">
                            <xm-bill-preview-expanded-data-panel
                                [tabletPlanGroup]="tabletPlanGroup"></xm-bill-preview-expanded-data-panel>
                        </xm-expandable>
                    </div>
                    <div class="panel" *ngIf="cmsData.smartWatchPlanGroup">
                        <div class="heading">
                            <span>{{ cmsData.smartWatchPlanGroup.watchPlanHeader }}</span>
                            <span>
                                <button class="xm-btn-link-light expand" (click)="smartWatchExpandFlag = !smartWatchExpandFlag"
                                    [attr.aria-expanded]="smartWatchExpandFlag">
                                    {{ cmsData.smartWatchPlanGroup.dataCost }}
                                    <xm-media-image class="expand-icon" size="height"
                                        [ngClass]="{'expanded': smartWatchExpandFlag}" [imageOptions]="expandIconOptions"
                                        aria-hidden="true"></xm-media-image>
                                </button>
                            </span>
                        </div>
                        <xm-expandable [expanded]="smartWatchExpandFlag">
                            <xm-bill-preview-expanded-data-panel
                                [smartWatchPlanGroup]="smartWatchPlanGroup"></xm-bill-preview-expanded-data-panel>
                        </xm-expandable>
                    </div>
                </div>
            </div>
            <!-- Service and Devices -->
            <div class="items">
                <h3 class="header-title">Service And Devices</h3>
                <div class="data">
                    <div class="panel" *ngFor="let serviceAndDevice of serviceAndDevices.devices; let i = index">
                        <div class="heading">
                            <span>{{ serviceAndDevice.nickname }}</span>
                            <button class="xm-btn-link-light expand" (click)="lineExpandFlags[i] = !lineExpandFlags[i]"
                                [attr.aria-expanded]="lineExpandFlags[i]">
                                {{ serviceAndDevice.price }}
                                <xm-media-image class="expand-icon" size="height"
                                    [ngClass]="{'expanded': lineExpandFlags[i]}" [imageOptions]="expandIconOptions"
                                    aria-hidden="true"></xm-media-image>
                            </button>
                        </div>
                        <div class="subheading">{{ serviceAndDevice.deviceDetails }}</div>
                        <xm-expandable class="expand-style" [expanded]="lineExpandFlags[i]">
                            <ng-container *ngFor="let charge of serviceAndDevice.charges">
                                <div class="service-detail">
                                    <div class="heading heading-wrap">
                                        <span class="title-wrap">{{ charge.charge }} </span>
                                        <span class="value value-wrap">{{ charge.amount }}</span>
                                    </div>
                                    <span *ngIf="charge.content" class="subheading">{{ charge.content }}</span>
                                </div>
                            </ng-container>
                        </xm-expandable>
                    </div>
                </div>
            </div>
            <!-- Discounts and Promotions -->
            <div class="items" *ngIf="planSwitchData?.promotions && planSwitchData?.promotions?.items?.length > 0">
                <h3 class="header-title">{{ planSwitchData.promotions.promotionHeader }}</h3>
                <div class="data">
                    <div *ngIf="planSwitchData.promotions.items.length > 0">
                        <div class="promotions" *ngFor="let promotion of planSwitchData.promotions.items">
                            <span class="header">{{ promotion.headerContent }}</span>
                            <span class="amount xm-btn-link-light">{{ promotion.amount}}</span>
                            <div *ngIf="promotion.subHeaderContent" class="subheading">{{ promotion.subHeaderContent }}</div>
                            <div *ngIf="promotion?.bodyContent" class="description row">
                                <span *ngFor="let bodyContent of formatBodyContent(promotion.bodyContent)" class="description-line">
                                    {{ bodyContent }}
                                </span>
                            </div>
                            <div *ngIf="promotion?.body" class="description row">
                                <span *ngFor="let bodyContent of formatBodyContent(promotion.body)" class="description-line">
                                    {{ bodyContent }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Estimated Monthly Total -->
            <div class="items" *ngIf="planSwitchData?.fees && planSwitchData?.fees?.fees?.length > 0">
                <h3 class="header-title">{{ planSwitchData.fees.feesHeader }}</h3>
                <div class="data">
                    <div *ngIf="planSwitchData.fees.fees.length > 0">
                        <div class="promotions">
                            <div class="fees-header-container">
                                <h2 class="fee-header"> {{ planSwitchData.fees.feesSubheader }}</h2>
                                <span class="amount xm-btn-link-light">
                                    {{ planSwitchData.fees.totalFee }}
                                </span>
                            </div>
                            <div class="description row" *ngFor="let fee of planSwitchData.fees.fees">
                                <span class="header">{{ fee.content }}</span>
                                <span class="amount xm-btn-link-light">{{ fee.amount}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="sub-header-container">{{ planSwitchData.bodyContent }}</p>
        </xm-expandable>
    </div>
</section>
